import { render, staticRenderFns } from "./OrderInvoice.vue?vue&type=template&id=6ccca3ca&scoped=true&"
import script from "./OrderInvoice.vue?vue&type=script&lang=js&"
export * from "./OrderInvoice.vue?vue&type=script&lang=js&"
import style0 from "./OrderInvoice.vue?vue&type=style&index=0&id=6ccca3ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccca3ca",
  null
  
)

export default component.exports